<template>
  
    <div style="width: 100vw;height: auto;background-color: #f5f7f9;position: relative;overflow-x: hidden">
      <div class="to-top"
           @click="toTop"
           v-if="showToTop"><i class="el-icon-arrow-up"
                               style="line-height: 1.8vw"></i></div>
      <tab-right class="right-tab" v-if="1" :subject="selectRule[0]"></tab-right>
      <div class="header">
        <div class="header-icon" @click="$router.push('/')"></div>
        <div class="header-title" id="font-test">同步实验资源</div>
        <div class="header-pic"
             @click="clickZone">
          <div class="user-card"
               ref="user-card-list"
               v-if="showCard">
            <div class="user-card-pic"></div>
            
              <div style='position: absolute;z-index:999'>
                <div class="user-msg" >
                  <span style="display: inline-block">{{username}}</span>
                  <span style="display: inline-block">{{'ID：'+(account.length>7?account.slice(0,7)+'...':account)}}</span>
                </div>
              </div>
            


            <div class="user-btn-list">
              <div class="user-card-btn"
                   @click="changeRight('toHome')">
                <img class="user-btn-pic"
                     src="http://data.xiyilab.com/web/main/static/home/p__基本资料大icon-拷贝.png">
                <div class="user-btn-text">个人中心</div>
              </div>
              <div class="user-card-btn"
                   @click="changeRight('exit')">
                <img class="user-btn-pic"
                     src="http://data.xiyilab.com/web/main/static/home/安全退出icon.png">
                <div class="user-btn-text"
                     @click="logout=true">安全退出</div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <el-dialog :visible="logout"
                 width="30%"
                 title="警告">
        <span>确认退出吗？当前未保存的操作将全部失效！！！</span>
        <template slot="footer">
          <el-button @click="logout=false">取消</el-button>
          <el-button @click="logOut">确认</el-button>
        </template>
      </el-dialog>
      <div class="select-action">
        <div class="search-action">
          <el-input placeholder="请输入关键词搜索"
                    v-model="searchInput"
                    class="search-input">
            <i slot="suffix"
               class="el-icon-close"
               style="line-height: 1.5vw;height: 1.5vw;cursor: pointer"
               v-if="searchInput.length>0"
               @click="clearInput"></i>
          </el-input>
          <span class="search-btn"
                id="search"
                @click="searchApp" style="font-size: 14px">开始搜索</span>
          <span style="display: inline-block"

                class="total-span">·&nbsp;&nbsp;共<span :style="{color:highLight}">{{appPage.total}}</span>项&nbsp;&nbsp;·</span>
        </div>
        <div style="display: flex;flex-direction: column; justify-content: center;align-items: center;flex-wrap: wrap">

          <crumbBread :router="selectRule" style="width: 98%;height: 2vw;margin: 0vh auto 1vh" @clearSearch="backSearch">
          </crumbBread>
          <div class="select-btn">
            <div class="select-version btn-list" v-if="selectRule.length===0">
              <div  style="display: flex;flex-wrap: nowrap">
                <span class="list-label" >学科</span><span style="height: 2vw;line-height: 2vw">：</span>
              </div>
              <div class="btn-group">
            <span style="display: inline-block"
                  class="version-btn"
                  v-for="item in subjectList"
                  v-if="!(item.name=='展示'&&!isSeller)"
                  @click="addTag(item.name,'subject')"
                  :class="{'active':item.active,'disable':!item.active}"><span :class="{'btn-label-4':item.name.length<=4,'btn-label-6':item.name.length>=3&&item.name.length<=6}" >{{item.name==='all'?'全部学科':item.name}}</span></span>

              </div>
            </div>
            <div class="select-version btn-list" v-if="selectRule.length===1&&selectRule[0].name!='展示'">
              <div  style="display: flex;flex-wrap: nowrap">
                <span class="list-label" >版本</span><span style="height: 2vw;line-height: 2vw">：</span>
              </div>
              <div class="btn-group">
            <span style="display: inline-block"
                  class="version-btn"
                  v-for="item in versionList"
                  @click="addTag(item.name,'publisher')"
                  :class="{'active':item.active,'disable':!item.active}"><span >{{item.name==='all'?'全部版本':item.name}}</span></span>
              </div>
            </div>
            <div class="select-grade btn-list" v-if="selectRule.length===2&&selectRule[0].name!='展示'">
              <div  style="display: flex;flex-wrap: nowrap">
                <span class="list-label" >教材</span><span style="height: 2vw;line-height: 2vw">：</span>
              </div>

              <div class="btn-group">
            <span style="display: inline-block"
                  class="version-btn"
                  v-for="item in gradeList"
                  @click="addTag(item.name,'grade')"
                  :class="{'active':item.active,'disable':!item.active}"><span >{{item.name==='all'?'全部教材':item.name}}</span></span>
              </div>
            </div>
            <div class="select-chapter btn-list" v-if="selectRule.length===3&&selectRule[0].name!='展示'">
              <div style="display: flex;flex-wrap: nowrap"><span class="list-label" >章节</span><span style="height: 2vw;line-height: 2vw">：</span></div>
              <div class="btn-group">
            <span style="display: inline-block"
                  class="version-btn"
                  v-for="item in chapterList"
                  @click="addTag(item.name,'chapter')"
                  :class="{'active':item.active,'disable':!item.active}"><span >{{item.name==='all'?'全部章节':item.name}}</span></span>

              </div>
              <!--            <span v-if="chapterList.length>12" style="width: 4vw;line-height: 2vw">更多<i class="el-icon-caret-bottom"></i></span>-->
            </div>
          </div>
        </div>


      </div>

      <div class="card-group">
        <div v-if="appCardList.length===0&&appPage.total!==0" style="margin:10vw auto;width: 20vw;height: 2vw;line-height: 2vw;font-size: 0.8vw;text-align: center;color: #b2b2b2">当前页暂无实验，请切换下一页</div>
        <div v-if="appCardList.length===0&&appPage.total===0" style="margin:10vw auto;width: 20vw;height: 2vw;line-height: 2vw;font-size: 0.8vw;text-align: center;color: #b2b2b2">当前筛选条件暂无实验</div>
        <AppCard class="app-card"
                 :page="appPage.page"
                 v-for="(item , index) in appCardList"
                 v-if="item.show"
                 :id="item.id"
                 :title="item.name"
                 :pic="item['platforms'][0]['preview_img_uri']||''"
                 :tag="item['platforms']"
                 :key="index"
                 :chapter="item['chapter']"
                 :grade="item.grade"
                 :publisher="item['publisher']"
                 :selectRule="selectRule"
                 :searchInput="searchInput"
                 :subject="item.subject"></AppCard>
      </div>
      <div style="width: 100%;height: 40px;display: flex;justify-content: center;align-items: center;margin-top: 5vh">
        <el-pagination class="pagination"
                       background
                       :current-page="appPage.page"
                       hide-on-single-page
                       @current-change="appPageChange"
                       :page-size="appPage.limit"
                       layout="prev, pager, next"
                       :total="appPage.total">
        </el-pagination>
      </div>

    </div>
  
</template>

<script>
import DevicePixelRatio from '@/plugins/devicePixelRatio';
import AppCard from '@/components/AppCard'

import { getToken } from '@/utils/auth'
import { getTemplate, getOnlineAppList } from '@/api/app'
import TabRight from '@/components/tabRight'
import crumbBread from '@/components/crumbBread'
export default {
  name: 'onlineApp',
  components: {
    TabRight,
    AppCard,
    crumbBread
  },
  layout:'home',
  mounted () {
    if(localStorage.getItem('isSeller')){
      if(localStorage.getItem('isSeller')=='true'){
        this.isSeller=true
      }
      else{
        this.isSeller=false
      }
    }
    let that=this
    document.onclick = function () {
      that.$nextTick(()=>{
        that.showCard=false
      })
    }
    getTemplate().then(res=>{
      if(res.status==='ok'){
        this.appTemplate=res.data

        if(this.$route.query.subject){
          this.selectRule.push({
            name:this.$route.query.subject,
            path:'/',
            type:'subject',
            disable:false
          })
        }
        if(this.$route.query.page){
          this.appPage.page=this.$route.query.page.toString()
        }
        if(this.$route.query.selectRule){
          let rule=JSON.parse(this.$route.query.selectRule||'')
          this.selectRule=rule
        }
        if(this.$route.query['search_word']){
          this.searchInput=this.$route.query['search_word']
        }
        if(this.selectRule.length<=0&&!this.$route.query.page&&!this.$route.query['search_word']){
          getOnlineAppList(this.appPage.page, this.appPage.limit).then(res => {
            console.log(res)
            this.appPage.total = res['page'].total
            this.appPage.page = res['page'].current_page
            for (let i = 0; i < res.data.length; i++) {
              if (res.data[i].usage === '同步实验') {
                if (this.appCardList.findIndex(item => item.id === res.data[i].id) === -1) {
                  res.data[i].show = true
                  this.appCardList.push(res.data[i])
                }
              }
            }
            // this.appPage.total = this.appCardList.length
            // for(let i=0;i<this.appCardList.length;i++){
            //   if(this.appCardList[i].tag.length<=0){
            //     this.appCardList[i].tag[0]=''
            //   }
            // }
          })
        }
      }

    })
    this.router = JSON.parse(localStorage.getItem('router'))
    if (window) {
      window.addEventListener('mousewheel', (e) => {
        if (e.pageY > 1500) {
          this.showToTop = true
        }
        else {
          this.showToTop = false
        }
      })
    }
    let token = localStorage.getItem('token')
    this.username = localStorage.getItem('username')
    this.account = localStorage.getItem('account')
    this.loginStatus = token ? true : false
    let userdata = {
      email: localStorage.getItem('email'),
      phone: localStorage.getItem('phone'),
      uid: localStorage.getItem('uid'),
      hasPwd: localStorage.getItem('hasPwd'),
      user_type: localStorage.getItem('user_type'),
      leastDate: localStorage.getItem('leastDate'),
      token: localStorage.getItem('token')
    }
    console.log(localStorage.getItem('email'))
    if (token) {
      this.$store.dispatch('User/reLogin', userdata)
    }
  },
  data () {
    return {
      isSeller:false,
      appTemplate:'',
      getCount:0,
      appPage: {
        page: 1,
        limit: 10,
        total: 0
      },
      highLight:'black',
      selectRule:[
        // { name: '首页', path: '/', disable: false },
      ],
      router: [],
      account: '',
      username: '',
      total: '',
      per_page: '',
      current_page: '',
      last_page: '',
      showCard: false,
      searchInput: '',
      tags: [],
      checkList: [],
      subjectList: [
        { name: 'all', active: false },
        { name: '物理', active: false },
        { name: '化学', active: false },
        { name: '生物', active: false },
        {name:'展示',active: false}
      ],
      versionList: [{ name: 'all', active: false },],
      gradeList: [{ name: 'all', active: false },],
      chapterList: [{ name: 'all', active: false },],
      appCardList: [],
      loginStatus: getToken() ? true : false,
      showToTop: false,
      logout: false,
    }

  },
  beforeDestroy () {
    if (window) {
      window.removeEventListener('mousewheel', () => {
        console.log('remove')
      })
    }
    // let flag=true
    // this.$router.beforeEach(function (to,from,next){
    //   console.log(to)
    //   if(to.path==='/appInfo'||to.path==='/appInfo/'){
    //     flag=false
    //     console.log(1)
    //   }
    //   next()
    // })
    // if(flag==true){
    //   console.log(0)
    //   localStorage.removeItem('selectRule')
    // }
  },
  created () {
      new DevicePixelRatio().init();
      if(localStorage.getItem('isSeller')){
        if(localStorage.getItem('isSeller')=='true'){
          this.isSeller=true
        }
        else{
          this.isSeller=false
        }
      }
      window.addEventListener('keydown',function (e){
        if(e.keyCode==13){
          document.getElementById('search').click()
        }
      })

      // let heightLimit=parseInt(window.innerHeight/400)
      // let widthLimit=parseInt(window.innerWidth/350)
      //
      // this.appPage.limit=(heightLimit*widthLimit)>this.appPage.limit?this.appPage.limit:(heightLimit*widthLimit)

  },
  watch:{
    appPage:function (){
      console.log(this.appPage.limit)
    },
    appCardList:function () {
      if(this.appCardList.length===0&&this.appPage.total===0){
        this.appPage.page=1
        this.appPage.total=0
        this.appPage.limit=10
      }
    },
    selectRule:function () {

      if(this.selectRule[0]&&this.selectRule[0].name==='生物'){
        this.highLight='rgb(65,221,157)'
      }
      if(this.selectRule[0]&&this.selectRule[0].name==='化学'){
        this.highLight='rgb(247,210,131)'
      }
      if(this.selectRule[0]&&this.selectRule[0].name==='物理'){
        this.highLight='#5eb2f7'
      }
      if(!this.selectRule[0]){
        this.highLight='#000'
      }
      if(this.selectRule.length>0){
        let type=this.selectRule[this.selectRule.length-1].type
        switch (type){
          case 'subject':{
            if(this.selectRule[0].name=='展示'){

            }
            else{
              this.versionList=[{name:'all',active:false}]
              for(let i=0;i<this.appTemplate.length;i++){
                if(this.selectRule.length-1>=0&&this.selectRule[this.selectRule.length-1].name.indexOf('全部')!=-1){
                  let data={
                    name:this.appTemplate[i]['publisher'],
                    active:false
                  }
                  if(this.versionList.findIndex(item=>item.name===data.name)==-1){
                    this.versionList.push(data)
                  }
                }
                else{
                  if(this.appTemplate[i]['subject']===this.selectRule[this.selectRule.length-1].name){
                    let data={
                      name:this.appTemplate[i]['publisher'],
                      active:false
                    }
                    if(this.versionList.findIndex(item=>item.name===data.name)==-1){
                      this.versionList.push(data)
                    }
                  }
                }

              }
            }
            break
          }
          case 'publisher':{
            this.gradeList=[{name:'all',active:false}]
            for(let j=0;j<this.appTemplate.length;j++){
              if(this.selectRule.length-1>=0&&this.selectRule[this.selectRule.length-1].name.indexOf('全部')!=-1){
                let data={
                  name:this.appTemplate[j]['grade'],
                  active:false
                }
                if(this.gradeList.findIndex(item=>item.name===data.name)==-1){
                  if(this.selectRule.length-2>=0&&this.selectRule[this.selectRule.length-2].name.indexOf('全部')!=-1){
                    this.gradeList.push(data)
                  }
                  else{
                    if(this.appTemplate[j]['subject']===this.selectRule[this.selectRule.length-2].name){
                      this.gradeList.push(data)
                    }
                  }
                }
              }
              else{
                if(this.appTemplate[j]['publisher']===this.selectRule[this.selectRule.length-1].name
                  &&
                  ( this.selectRule.length-2>=0&&this.selectRule[this.selectRule.length-2].name.indexOf('全部')!=-1
                    ||
                    this.appTemplate[j]['subject']===this.selectRule[this.selectRule.length-2].name
                  )){
                  let data={
                    name:this.appTemplate[j]['grade'],
                    active:false
                  }
                  if(this.gradeList.findIndex(item=>item.name===data.name)==-1){
                    if(this.selectRule.length-2>=0&&this.selectRule[this.selectRule.length-2].name.indexOf('全部')!=-1){
                      this.gradeList.push(data)
                    }
                    else{
                      if(this.appTemplate[j]['subject']===this.selectRule[this.selectRule.length-2].name){
                        this.gradeList.push(data)
                      }
                    }
                  }
                }
              }

            }
            break
          }
          case 'grade':{
            this.chapterList=[{name:'all',active:false}]
            let chapter=[]
            let thirdList=[]
            let loopValue=this.appTemplate

            for(let m=0;m<this.selectRule.length;m++){
              if(this.selectRule[m].name.indexOf('全部')==-1){
                for(let n=0;n<loopValue.length;n++){
                  if(this.selectRule[m].name===loopValue[n][this.selectRule[m].type]){
                    thirdList.push(loopValue[n])
                  }
                }
                loopValue=thirdList
                thirdList=[]
              }
            }
            console.log(loopValue)
            let name
            for(let m=0;m<loopValue.length;m++){
              name=loopValue[m]['chapter'].indexOf('章')!=-1?'章':'单元'
              let range
              if(loopValue[m]['chapter'].indexOf('章')!=-1){
                range=loopValue[m]['chapter'].substring(0,loopValue[m]['chapter'].indexOf('章'))
              }
              else{
                range=loopValue[m]['chapter'].substring(0,loopValue[m]['chapter'].indexOf('单元'))
              }
              console.log(range)
              let max=parseInt(loopValue[m]['chapter'].split('-')[1])
              let min=parseInt(loopValue[m]['chapter'].split('-')[0])
              for(let item=min;item<=max;item++){
                chapter.push(item)
              }
            }
            chapter=[...new Set(chapter)]
            for(let m=0;m<chapter.length;m++){
              this.chapterList.push({
                name:'第'+this.toChineseNum(chapter[m])+name,
                active: false
              })
            }
            break
          }
          default:{
            break
          }
        }
      }



      this.appCardList=[]
      // &search_word=电&subject=物理&grade=八年级&chapter=第一章
      let api=''
      for(let i=0;i<this.selectRule.length;i++){
        if(this.selectRule[0].name=='展示'){
          api+='&tag=演示'
          break
        }
        if(this.selectRule[i].name.indexOf('全部')===-1){
          api+='&'+this.selectRule[i].type+'='+this.selectRule[i].name
        }
      }
      if(this.searchInput.length>0){
        api+='&search_word='+this.searchInput
      }
      let page
      if(this.getCount==0){
        page=this.$route.query.page?this.appPage.page:1
      }
      else{
        page=1

      }
      this.appPage.page=page
      getOnlineAppList(page, this.appPage.limit,api).then(res => {
        this.getCount++;
        console.log(res)
        if(this.appPage.page>res['page'].last_page){
          getOnlineAppList(res['page'].last_page, this.appPage.limit,api).then(res=>{
            this.appPage.total = res['page'].total
            this.appPage.page = res['page'].current_page
            for (let i = 0; i < res.data.length; i++) {
              if (res.data[i].usage === '同步实验') {
                if (this.appCardList.findIndex(item => item.id === res.data[i].id) === -1) {
                  res.data[i].show = true
                  this.appCardList.push(res.data[i])
                }
              }
            }
          })
        }
        else{
          this.appPage.total = res['page'].total
          this.appPage.page = res['page'].current_page
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].usage === '同步实验') {
              if (this.appCardList.findIndex(item => item.id === res.data[i].id) === -1) {
                res.data[i].show = true
                this.appCardList.push(res.data[i])
              }
            }
          }
        }

        // this.appPage.total = this.appCardList.length
        // for(let i=0;i<this.appCardList.length;i++){
        //   if(this.appCardList[i].tag.length<=0){
        //     this.appCardList[i].tag[0]=''
        //   }
        // }
      })
    }
  },
  methods: {
    clickZone(e){
      e.stopPropagation?e.stopPropagation():e.cancelBubble=true;
      this.showCard=!this.showCard
    },
    toChineseNum (num) {
      var changeNum = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十'],
        newNum = '',
        arr = num.toString().split('');
      arr[0] = parseInt(arr[0]) - 1;
      if (arr[0] == -1 && arr.length == 1) { return '零'; }
      if (arr.length > 1) {
        arr[1] = parseInt(arr[1]) - 1;
        if (!arr[0]) {
          newNum = !arr[0] && arr[1] == -1 ? changeNum[9] : changeNum[9] + changeNum[arr[1]];
        } else {
          newNum = (changeNum[arr[0]] + changeNum[9]) + (changeNum[arr[1]] ? changeNum[arr[1]] : '')
        }
      } else {
        newNum = changeNum[arr[0]];
      }
      return newNum;
    },
    backSearch(index){

      this.selectRule=this.selectRule.slice(0,index)
      console.log(this.selectRule)
    },
    toTop () {
      $('.to-top').fadeOut(100)
      this.showToTop = false
      $('body,html').animate({
          scrollTop: 0
        },
        500);

    },
    logOut () {
      this.$store.dispatch('User/logout')
      this.logout = false
      localStorage.clear()
      window.close()
      // setTimeout(() => {
      //
      //   if (this.$route.path !== '/') {
      //     this.$router.push('/')
      //   }
      //   else {
      //     this.$router.go(0);
      //   }
      // }, 500)
    },
    addTag (name,type) {
      if(name!=='all'){
        this.selectRule.push({
          name:name,
          path:'/',
          type:type,
          disable:false
        })
      }
      else{
        let tagName
        switch (type){
          case 'subject':tagName='全部学科';break
          case 'publisher':tagName='全部版本';break
          case 'chapter':tagName='全部章节';break
          case 'grade':tagName='全部教材';break
        }
        this.selectRule.push({
          name:tagName,
          path:'/',
          type:type,
          disable:false
        })
      }
    },

    changeSelectType () {
      console.log(this.checkList)

      if (this.checkList.length > 0) {
        for (let i = 0; i < this.appCardList.length; i++) {
          this.appCardList[i].show = false
        }
        for (let i = 0; i < this.appCardList.length; i++) {
          for (let j = 0; j < this.appCardList[i]['platforms'].length; j++) {
            if (this.checkList.findIndex(item => item === this.appCardList[i]['platforms'][j].platform) !== -1) {
              this.appCardList[i].show = true
              break;
            }
          }
        }
      }
      else {
        for (let i = 0; i < this.appCardList.length; i++) {
          this.appCardList[i].show = true
        }
      }
    },
    searchApp () {
      this.appCardList = []
      let api = '&search_word=' + this.searchInput
      for(let i=0;i<this.selectRule.length;i++){
        if(this.selectRule[i].name.indexOf('全部')===-1){
          api+='&'+this.selectRule[i].type+'='+this.selectRule[i].name
        }
      }
      getOnlineAppList(this.appPage.page, this.appPage.limit,api).then(res => {
        console.log(res)
        if(this.appPage.page>res['page'].last_page){
          getOnlineAppList(res['page'].last_page, this.appPage.limit,api).then(res=>{
            this.appPage.total = res['page'].total
            this.appPage.page = res['page'].current_page
            for (let i = 0; i < res.data.length; i++) {
              if (res.data[i].usage === '同步实验') {
                if (this.appCardList.findIndex(item => item.id === res.data[i].id) === -1) {
                  res.data[i].show = true
                  this.appCardList.push(res.data[i])
                }
              }
            }
          })
        }
        else{
          this.appPage.total = res['page'].total
          this.appPage.page = res['page'].current_page
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].usage === '同步实验') {
              if (this.appCardList.findIndex(item => item.id === res.data[i].id) === -1) {
                res.data[i].show = true
                this.appCardList.push(res.data[i])
              }
            }
          }
        }
        // this.appPage.total = this.appCardList.length
        // for(let i=0;i<this.appCardList.length;i++){
        //   if(this.appCardList[i].tag.length<=0){
        //     this.appCardList[i].tag[0]=''
        //   }
        // }
      })
    },
    clearInput () {
      this.searchInput = ''
      this.appCardList=[]
      let api=''
      for(let i=0;i<this.selectRule.length;i++){
        if(this.selectRule[i].name.indexOf('全部')===-1){
          api+='&'+this.selectRule[i].type+'='+this.selectRule[i].name
        }
      }
      getOnlineAppList(this.appPage.page, this.appPage.limit,api).then(res => {
        console.log(res)
        if(this.appPage.page>res['page'].last_page){
          getOnlineAppList(res['page'].last_page, this.appPage.limit,api).then(res=>{
            this.appPage.total = res['page'].total
            this.appPage.page = res['page'].current_page
            for (let i = 0; i < res.data.length; i++) {
              if (res.data[i].usage === '同步实验') {
                if (this.appCardList.findIndex(item => item.id === res.data[i].id) === -1) {
                  res.data[i].show = true
                  this.appCardList.push(res.data[i])
                }
              }
            }
          })
        }
        else{
          this.appPage.total = res['page'].total
          this.appPage.page = res['page'].current_page
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].usage === '同步实验') {
              if (this.appCardList.findIndex(item => item.id === res.data[i].id) === -1) {
                res.data[i].show = true
                this.appCardList.push(res.data[i])
              }
            }
          }
        }
        // this.appPage.total = this.appCardList.length
        // for(let i=0;i<this.appCardList.length;i++){
        //   if(this.appCardList[i].tag.length<=0){
        //     this.appCardList[i].tag[0]=''
        //   }
        // }
      })
    },
    appPageChange (page) {
      this.appCardList=[]
      let api=''
      for(let i=0;i<this.selectRule.length;i++){
        if(this.selectRule[0].name=='展示'){
          api+='&tag=演示'
          break
        }
        if(this.selectRule[i].name.indexOf('全部')===-1){
          api+='&'+this.selectRule[i].type+'='+this.selectRule[i].name
        }
      }
      if(this.searchInput.length>0){
        api+='&search_word='+this.searchInput
      }
      getOnlineAppList(page, this.appPage.limit,api).then(res => {
        console.log(res)
        if(this.appPage.page>res['page'].last_page){
          getOnlineAppList(res['page'].last_page, this.appPage.limit,api).then(res=>{
            this.appPage.total = res['page'].total
            this.appPage.page = res['page'].current_page
            for (let i = 0; i < res.data.length; i++) {
              if (res.data[i].usage === '同步实验') {
                if (this.appCardList.findIndex(item => item.id === res.data[i].id) === -1) {
                  res.data[i].show = true
                  this.appCardList.push(res.data[i])
                }
              }
            }
          })
        }
        else{
          this.appPage.total = res['page'].total
          this.appPage.page = res['page'].current_page
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].usage === '同步实验') {
              if (this.appCardList.findIndex(item => item.id === res.data[i].id) === -1) {
                res.data[i].show = true
                this.appCardList.push(res.data[i])
              }
            }
          }
        }
        // this.appPage.total = this.appCardList.length
        // for(let i=0;i<this.appCardList.length;i++){
        //   if(this.appCardList[i].tag.length<=0){
        //     this.appCardList[i].tag[0]=''
        //   }
        // }
      })
    },
    changeRight (title) {
      console.log(title)
      if(title==='toHome'){
        this.$router.push('/home')
      }
    },

  }

}
</script>

<style scoped>
*{
  font-family: test;
}
.right-tab {
  position: absolute;
  right: 1vw;
  top: 20vh;
}
.card-group {
  width:88vw;
  height: 63vh;
  margin-top: 2vh;
  margin-bottom: 2vh;
  margin-left: 7vw;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
}
.app-card {
  margin: 2vh 0.8vw 2vh;
}
.header {
  width: 100%;
  height: 8vh;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
  background-color: white;
}
.header-icon {
  width: 6vw;
  height: 3vw;
  margin-top: 0.5vw;
  margin-left: 3vw;
  background-image: url("http://data.xiyilab.com/web/main/static/首页/资源 2.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
}
.header-pic {
  height: 2vw;
  width: 2vw;
  margin-top: 1vw;
  margin-right: 3vw;
  margin-left: 3vw;
  border-radius: 50%;
  background-image: url("http://data.xiyilab.com/web/main/static/home/小头像.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  cursor: pointer;
  position: relative;
}
.user-card {
  position: absolute;
  top: 3vw;
  right: -1vw;
  min-width: 100px;
  max-width: 200px;
  width: 8vw;
  display: flex;
  flex-direction: column;
  z-index: 999;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.user-card-pic {
  width: 8vw;
  height: 4vw;
  min-width: 100px;
  min-height: 40px;
  max-height: 120px;
  background-image: url("http://data.xiyilab.com/web/main/static/home/p__卡片背景.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.user-msg {
  display: flex;
  flex-direction: column;
  width: 8vw;
  height: 4vw;
  min-width: 100px;
  min-height: 40px;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 0.7vw;
}
.user-card-btn {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  height: 2vw;
  min-height: 25px;
  cursor: pointer;
  width: 100%;
}
.user-btn-pic {
  object-fit: contain;
}
.user-btn-text {
  line-height: 2vw;
  height: 2vw;
  font-size: 0.7vw;
  text-align: center;
  margin-left: 1.5vw;
  white-space: nowrap;
}
.user-card-btn:hover {
  background-color: #f7e35e;
}
.header-title {
  margin: 1vw auto;
  height: 2vw;
  line-height: 2vw;
  font-size: 1.2vw;
  text-align: center;
}
.select-action {
  width: 86%;
  margin: 1vh auto 0;
  display: flex;
  flex-direction: column;
}
.search-action {
  height: 40px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  margin-left: 0.8vw;
  margin-bottom: 0.5vh;
}
.search-input {
  width: 10vw;
  min-width: 200px;
  height: 1.5vw;
  margin-top: auto;
  margin-bottom: auto;
  margin-right: 1vw;
}

.search-btn {
  height: 1.5vw;
  width: 8rem;
  margin-top: auto;
  margin-bottom: auto;
  border-radius: 40px;
  line-height: 1.5vw;
  display: inline-block;
  background-color: #5eb2f7;
  color: white;
  border: none;
  text-align: center;
  white-space: nowrap;
  margin-right: 1vw;
  font-size: 0.7vw;
  cursor: pointer;
}
.total-span {
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 0.8vw;
}
.el-input--medium,
/deep/ .el-input__inner {
  border: none;
  border-radius: 1.5vw;
  height: 1.5vw;
}
.select-btn {

  width: 98%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.btn-list {
  width: 100%;
  margin-left: 0vw;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.list-label {
  height: 2vw;
  line-height: 2vw;
  margin-left: 0vw;
  margin-right: 0vw;
  cursor: pointer;
  display: inline-block;
  text-align: justify;
  vertical-align: top;
  font-size: 0.7vw;
  min-width: 2vw;
}
.btn-label-4 {
  height: 2vw;
  margin-left: 0vw;
  margin-right: 0vw;
  cursor: pointer;
  display: inline-block;
  text-align: justify;
  vertical-align: top;
  font-size: 0.7vw;
  min-width: 1.8vw;
}
.btn-label-4::after{
  width: 100%;
  display: inline-block;
  content: "";
}
.btn-label-6 {
  height: 2vw;
  margin-left: 0vw;
  margin-right: 0vw;
  cursor: pointer;
  display: inline-block;
  text-align: justify;
  vertical-align: top;
  font-size: 0.7vw;
  min-width: 3vw;
}
.btn-label-6::after{
  width: 100%;
  display: inline-block;
  content: "";
}
.list-label::after{
  width: 100%;
  display: inline-block;
  content: "";
}
.btn-group {
  margin-right: auto;
  margin-left: 0.5vw;
}
.version-btn {
  line-height:1.5vw;
  height: 1.5vw;
  margin-top: 0.25vw;
  margin-left: 0.3vw;
  margin-right: 0.3vw;
  cursor: pointer;
  text-align: center;
  vertical-align: top;
  min-width: 4vw;
  font-size: 0.7vw;
  border: 1px #5eb2f7 solid;
  border-radius: 1.5vw;
}

/*.version-btn::after {*/
/*  width: 100%;*/
/*  display: inline-block;*/
/*  content: "";*/
/*}*/
.version-btn:hover {
  background-color: #5eb2f7;
  color: white;
}
.version-btn>span{
  display: inline-block;
  margin-left: 0.5vw;
  margin-right: 0.5vw;
}
.active {
  color: #5eb2f7;
}
.disable {
  color: black;
}
.select-type {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
}
.to-top {
  position: fixed;
  display: flex;
  flex-direction: column;
  float: right;
  top: 40vw;
  right: 3vw;
  text-align: center;
  font-size: 1vw;
  cursor: pointer;
  z-index: 999;
  width: 2vw;
  height: 2vw;
  border-radius: 50%;
  background-color: white;
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.bread-line{
  height: 1px;
  width: 10vw;
  background-color:rgba(175, 175, 175, 0.4);
  margin-right: 74vw;
}
</style>
